import { InMemoryCacheConfig } from "@apollo/client";

// ServiceTime ids from napi are not unique across services: the id is a base64 hash of
// pickupTime-dropoffTime-skedRun truncated to 32 chars, which drops the skedRun portion.
// Slots that share a pickup time therefore share an id, so Apollo's default normalization
// would merge them into one cache entry and leak one service's skedRun/tripId onto another
// (e.g. a scheduled shuttle run bleeding onto a private van). keyFields:false keeps
// ServiceTime embedded within its parent Service so each service keeps its own times.
//
// TranslationEntry ids from the `translations` query are only unique WITHIN a list — the
// same id appears across lists (e.g. driver #15 and vehicle #15 on lyntest22). Default
// normalization keys by __typename+id, so those entries collapse into one record and one
// list's name leaks onto another (the drivers grid rendered a driver's name as the assigned
// vehicle). keyFields:false keeps each entry embedded within its parent TranslationList.
export const cacheConfig: InMemoryCacheConfig = {
  typePolicies: {
    ServiceTime: { keyFields: false },
    TranslationEntry: { keyFields: false },
  },
};
